import { User } from '@/components/default/types/User';
import { createSlice } from '@reduxjs/toolkit';

interface AuthState {
    user: User | null;
    token: string | null;
    role: string | null;
    permissions: string[];
    isAuthenticated: boolean;
  }


const initialState: AuthState = {
  user: null,
  token: null,
  role: null,
  permissions: [],
  isAuthenticated: false,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    loginSuccess: (state, action) => {
      const { user, token, role, permissions } = action.payload;
      state.user = user;
      state.token = token;
      state.role = role;
      state.permissions = permissions;
      state.isAuthenticated = true;
    },
    logoutSuccess: (state) => {
      state.user = null;
      state.token = null;
      state.role = null;
      state.permissions = [];
      state.isAuthenticated = false;
    },
    setToken: (state, action) => {
      state.token = action.payload;
    },
    updateUser: (state, action) => {
      state.user = action.payload;
    },
    updateUserData: (state, action) => {
        if (state.user) {
          state.user = { ...state.user, ...action.payload }; // merge updates into existing user
        }
      }
  },
});

export const { loginSuccess, logoutSuccess, setToken, updateUser,updateUserData } = authSlice.actions;

export default authSlice.reducer;
